import { LogicContext } from '../types';

import { JackpotsV2ResponseType } from '../../../types/jackpotTypes';
import { fromEntries } from 'src/utils/lodash-alternatives';
import config from '../../../config';
import { fetchJackpotsV2 } from '../../../model/jackpotsV2';
import { isSingleJackpot } from '../utils';

export const refetchStaleJackpots = async (context: LogicContext) => {
  const {
    features: { jackpotsV2 },
    intervals: { jackpotsV2Check },
  } = config;
  if (jackpotsV2?.mode !== 'enabled' || !jackpotsV2Check) {
    return {};
  }

  const currency = context.user?.currency || config.default_currency;
  const currentTimestamp = Date.now();
  const jackpotResponses = Object.entries(context.currentJackpotsV2).reduce(
    (acc, [provider, jackpotResponse]) => {
      const gamesJackpotCodes = Object.entries(jackpotResponse)
        .filter(([jpCode, jackpot]) => {
          const jpUpdateInterval =
            isSingleJackpot(jackpot) && jackpot.value.updateInterval;
          const updateInterval = jpUpdateInterval || jackpotsV2Check;
          const jpTimestamp = Date.parse(jackpot.timestamp);
          return jpTimestamp + updateInterval < currentTimestamp;
        })
        .map(([jpCode]) => jpCode);
      if (gamesJackpotCodes.length) {
        const jackpot = fetchJackpotsV2({
          currency,
          gamesJackpotCodes,
          provider: provider.toLowerCase(),
        }).then(response => [provider, response] as const);
        acc.push(jackpot);
      }
      return acc;
    },
    [] as Promise<readonly [string, JackpotsV2ResponseType]>[]
  );
  if (!Object.fromEntries) Object.fromEntries = fromEntries;
  const jackpots = Object.fromEntries(await Promise.all(jackpotResponses));

  return { jackpots };
};
